<template>
    <div class="notes">
        <div class="info">
            <h3 class="bullet01">В день, предшествующий медицинскому обследованию</h3>
            <p class="bullet03 depth">следует избегать злоупотребления алкоголем и переутомления.</p>
            <p class="bullet03 depth">Рекомендуем отдохнуть и выспаться. Заранее заполните анкету и принесите с собой на медицинское обследование.</p>

            <h4 class="bullet02 depth">Воздержание от приема пищи</h4>
            <p class="bullet03 depth">Разрешается легкий ужин не позднее 19:00 ч.</p>
            <p class="bullet03 depth">Следует воздерживаться от приема пищи после 21:00 ч. (В том числе от воды, жевательной резинки или сигарет)</p>

            <h4 class="bullet02 depth">Анализ кала</h4>
            <p class="bullet03 depth">По возможности возьмите образец кала за день до обследования.</p>
            <p class="bullet03 depth">Если у вас запланирована колоноскопия, мы вручим вам отдельное руководство с подробной информацией о режиме питания и способе введения средства для очистки кишечника.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">в день обследования</h3>
            <p class="bullet03 depth">Следует избегать утреннего приема пищи, сигарет и жевательной резинки в день обследования.</p>
            <p class="bullet03 depth">На прием принесите с собой заполненную анкету, контейнер с образцом кала, очки или контактные линзы.</p>
            <p class="bullet03 depth">Анализ мочи также включен в список процедур, поэтому вручите ваш образец после посещения регистратуры.</p>

            <h4 class="bullet02 depth">Прием лекарств</h4>
            <p class="bullet03 depth">лекарства для регулирования кровяного давления, противосудорожные средства: выпейте глоток воды утром в день обследования (примерно в 6 ч. утра)</p>
            <p class="bullet03 depth">Лекарства от диабета (в том числе инъекции инсулина): введение инъекций инсулина или лекарственных средств следует прекратить с начала воздержания от пищи.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Прочее</h3>
            <p class="bullet03 depth">не брать с собой ценных вещей.</p>
            <p class="bullet03 depth">Женщины репродуктивного возраста должны подтвердить свою беременность перед медицинским обследованием.</p>
            <p class="bullet03 depth">Пациенткам не рекомендуется проходить обследование во время менструации; женщины, перенесшие гистероэктомию, должны также пройти гинекологическое обследование на наличие аномалий внутритазовых
                органов.Антикоагулянты могут вызвать кровотечение во</p>
            <p class="bullet03 depth">время эндоскопической биопсии или полипэктомии; пациенты, принимающие антикоагулянт (например, аспирин), должны проконсультироваться у врача, назначившего лекарство, по поводу продолжения или приостановки приема
                не позднее, чем за неделю до обследования, и сообщить нам об этом в день обследования.</p>
            <p class="bullet03 depth">На процедуру эндоскопического обследования с седацией с сохранением сознания следует приходить с сопровождением, и помните, что вам будет запрещено садиться за руль до конца дня.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Следует приостановить прием запрещенных лекарственных средств</h3>
            <p class="bullet03 depth">медикаментов от диабета с метформином (например, Диабекс, Янумет, Глупа, Тражента-дуо, Амарил-М) на 48 часов после обследования, если в любом из тестов применяется контрастное вещество.</p>
            <p class="bullet03 depth">Антитромботические средства и антикоагулянты могут вызвать кровотечение во время эндоскопической биопсии или полипэктомии; пациенты, принимающие антитромботическое средство или антикоагулянт, должны
                проконсультироваться у врача, назначившего
                лекарство, по поводу продолжения или приостановки приема не позднее, чем за неделю до обследования, и сообщить нам об этом в день обследования.</p>

            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_01.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_02.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_03.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_04.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_05.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">Примеры антитромботических средств</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_06.jpg" alt=""></div>
                    <div class="tit">Aspirin Protect Tab</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_07.jpg" alt=""></div>
                    <div class="tit">Astrix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_08.jpg" alt=""></div>
                    <div class="tit">Plavix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_09.jpg" alt=""></div>
                    <div class="tit">Pletaal Tab</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">примеры антикоагулянтов</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_10.jpg" alt=""></div>
                    <div class="tit">Warfarin</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_11.jpg" alt=""></div>
                    <div class="tit">Paradaxa</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_12.jpg" alt=""></div>
                    <div class="tit">Xarelto</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_13.jpg" alt=""></div>
                    <div class="tit">Eliquis</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_14.jpg" alt=""></div>
                    <div class="tit">Lixiana</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>